<template>
    <div class="btn-div">
        <b-button :to="path" class="next-button">
            {{$t('home.profile.buttonText')}}
        </b-button>
    </div>
</template>

<script>
    export default {
        name: 'HomeTitle',
        props: ['path']
    }
</script>

<style lang="scss" scoped>
    @import '../../assets/scss/custom/vars';

    .next-button {
        background-color: $omyfu-yellow;
        border-radius: 0;
        border: 0px;
        &:hover {
            background-color: $omyfu-hover;
            text-decoration: none;
        }
    }
    .btn-div {
        padding-top: 24px;
    }
</style>



// WEBPACK FOOTER //
// src/components/home/HomeLinkComponent.vue